var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { appear: "", name: "fade" } }, [
    _c("div", { staticClass: "d-flex flex-column" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _c("div", { attrs: { id: "space-filler" } }),
          _c("appAdminSidebar"),
          _c("appHeader"),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "container p-3" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchQuery,
                expression: "searchQuery",
              },
            ],
            staticClass: "form-control mb-3",
            attrs: { type: "text", placeholder: "Search gift card by name..." },
            domProps: { value: _vm.searchQuery },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.searchQuery = $event.target.value
              },
            },
          }),
          _vm._l(_vm.filteredBrands, function (brand) {
            return _c(
              "div",
              { key: brand.brandKey, staticClass: "mb-4 card p-3 shadow-sm" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center cursor-pointer",
                    on: {
                      click: function ($event) {
                        return _vm.toggleSelectedBrand(brand.brandKey)
                      },
                    },
                  },
                  [
                    _c("h5", [_vm._v(_vm._s(brand.brandName))]),
                    _c("img", {
                      staticStyle: { "max-height": "40px" },
                      attrs: {
                        src: brand.imageUrls["130w-326ppi"],
                        alt: "brand",
                      },
                    }),
                  ]
                ),
                _vm.selectedBrandKey === brand.brandKey
                  ? _c("div", { staticClass: "mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(brand.items, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.utid,
                              staticClass: "col-md-4 col-sm-6 mb-3",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "card h-100 shadow-sm" },
                                [
                                  _c("div", { staticClass: "card-body" }, [
                                    _c(
                                      "h6",
                                      { staticClass: "card-title mb-2" },
                                      [_vm._v(_vm._s(item.rewardName))]
                                    ),
                                    _c("p", { staticClass: "mb-1" }, [
                                      _c("strong", [_vm._v("Type:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.valueType.replace("_VALUE", "")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("p", { staticClass: "mb-1" }, [
                                      _c("strong", [_vm._v("Currency:")]),
                                      _vm._v(
                                        " " + _vm._s(item.currencyCode) + " "
                                      ),
                                    ]),
                                    _c("p", { staticClass: "mb-1" }, [
                                      _c("strong", [_vm._v("UTID:")]),
                                      _vm._v(" " + _vm._s(item.utid)),
                                    ]),
                                    _c("p", { staticClass: "mb-1" }, [
                                      _c("strong", [_vm._v("Brand Key:")]),
                                      _vm._v(" " + _vm._s(brand.brandKey)),
                                    ]),
                                    item.valueType === "FIXED_VALUE"
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "badge bg-success" },
                                            [
                                              _vm._v(
                                                "Amount: $" +
                                                  _vm._s(
                                                    item.faceValue.toFixed(2)
                                                  )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : item.valueType === "VARIABLE_VALUE"
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge bg-warning text-dark",
                                            },
                                            [
                                              _vm._v(
                                                "Range: $" +
                                                  _vm._s(
                                                    item.minValue.toFixed(2)
                                                  ) +
                                                  " - $" +
                                                  _vm._s(
                                                    item.maxValue.toFixed(2)
                                                  )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          _c("appFooter"),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }